import {ThunkAction} from 'redux-thunk'
import {ISignInState} from '@telstra-connect/login/state'
import {
  loadSitesMapdataStart,
  loadSitesMapDataSuccess,
  loadSitesMapDataError,
  updateCompaniesFilterSuccessInt,
  loadSitesMapDataSuccessInt,
} from '../actions/load-sites-map-data'
import {ISitesListMapDataPayLoad} from './payload'
import {get as HttpGet, IGetProps} from '@telstra-connect/utils/http/requests/get'
import {getFormatedTime} from '@telstra-connect/utils/data/date-helpers'
import {
  ISitesMapDataResponse,
  ISiteCompanyFilterInternational,
  ISitesMapDataResponseInt,
} from '../state/sites-map-data'

export function loadSitesMapData(
  searchTerms?: string,
  timerange?: string,
  isInternationalUser?: boolean,
  companyId?: string,
): ThunkAction<void, ISignInState, void> {
  return (dispatch, getState) => {
    dispatch(loadSitesMapdataStart())
    const params = {
      searchTerms,
      timerange,
    }

    const request: IGetProps = {
      url: isInternationalUser
        ? '/networks-and-internet/v1/international/sites'
        : '/service-performance/sites/map',
      state: getState(),
      queryString: params,
    }

    if (isInternationalUser) {
      request.customHeaders = {
        'company-id': companyId,
      }
    }

    return HttpGet<ISitesListMapDataPayLoad>(request)
      .then((result) => {
        const sites = result.sites && Array.isArray(result.sites) ? result.sites : []
        if (isInternationalUser) {
          const checkedResult: ISitesMapDataResponseInt = {
            sites,
            originalSites: sites,
            numberOfSites: 'numberOfSites' in result ? result.numberOfSites : 0,
            stateId: result.stateId,
            refreshInterval: 'refreshInterval' in result ? result.refreshInterval : 300000,
            searchTermsCharacterLimit:
              'searchTermsCharacterLimit' in result ? result.searchTermsCharacterLimit : 3,
            mapBoundingBox: result.mapBoundingBox,
            mapCentroid: result.mapCentroid,
            lastPolledTime:
              'lastPolledTime' in result ? getFormatedTime(result.lastPolledTime) : '',
          }
          dispatch(loadSitesMapDataSuccessInt(checkedResult))
        } else {
          const checkedResult: ISitesMapDataResponse = {
            sites,
            numberOfSites: 'numberOfSites' in result ? result.numberOfSites : 0,
            stateId: result.stateId,
            refreshInterval: 'refreshInterval' in result ? result.refreshInterval : 300000,
            searchTermsCharacterLimit:
              'searchTermsCharacterLimit' in result ? result.searchTermsCharacterLimit : 3,
            mapBoundingBox: result.mapBoundingBox,
            mapCentroid: result.mapCentroid,
            lastPolledTime:
              'lastPolledTime' in result ? getFormatedTime(result.lastPolledTime) : '',
          }
          dispatch(loadSitesMapDataSuccess(checkedResult))
        }
      })
      .catch((error) => {
        if (error.apiError && error.apiError.message === 'Invalid Search Term provided.') {
          dispatch(loadSitesMapDataError(error.apiError.message))
        } else {
          dispatch(loadSitesMapDataError('Error loading sites list'))
        }
      })
  }
}

export function applyCompaniesFilterOnMapSites(
  filter: ISiteCompanyFilterInternational,
): ThunkAction<void, ISignInState, void> {
  return (dispatch) => {
    dispatch(updateCompaniesFilterSuccessInt(filter))
  }
}
